import { combineReducers } from 'redux';
import { SettingsReducer } from './Settings/services/reducer';

export const aboutModuleReducer = combineReducers({
  SettingsReducer,
});

export type AboutModuleReducer = ReturnType<typeof aboutModuleReducer>;
